import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DishServices } from "../../../services";
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'page-dish-partial-description',
    templateUrl: 'dish-partial-description.html',
})
export class DishPartialDescriptionPage {
    @Input() update_state;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices,
        public http: HttpClient,
        public alertCtrl: AlertController) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-name/dish-partial-description/dish-partial-description.ts